import { CloseOutlined, DeleteOutlined } from "@ant-design/icons"
import { Button, Modal, Form, Input, Select, DatePicker, ConfigProvider, Tooltip, TreeSelect, InputNumber, SelectProps, } from "antd"
import viVN from 'antd/locale/vi_VN';
import '../../../../styles.scss'
import { dataInteractionCategory, dataSurveyInformationInteractionType, SURVEYTYPE } from "../../../../../../services/data";
import React, { useEffect, useRef, useState } from "react";
import { getSLAnswerOptions, getSLQuestionSurvey, getSLVehicleEngineNos, ISelectOption, ITag } from "../../../../../../api/selectOptions/selectOptionsApi";
import { convertToAntdOptions, createGroupedSelectOptions, fommatSelectOption, fommatSelectOptionToUpperCase, fommatSelectOptionUnitByUser, formatIssuingUnitTree } from "../../../../../../until";
import useToast from "../../../../../../hook/useToast";
import useLoading from "../../../../../../hook/useLoading";
import useDebounce from "../../../../../../hook/useDebounce";
import { FormProps } from "antd/lib";
import useThrottle from "../../../../../../hook/useThrottle";
import { getSLCarByContractNo, getSLCarByInvoiceNo, getSLCarByPlateNumber, getSLCarsByCarLineIdAndCategoryCarId, getSLContracts, getSLInfoExportDate, getSLInfoPresentMileAge, getSLInvoices, getSLVehicleChassisNumbers, getSLVehiclePlateNumbers } from "../../../../../../api/selectOption/selectOptionsApi";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../../../store/slices/infoUserSlice";
import dayjs from "dayjs";
import { addCustomerSurvey, editCustomerSurvey, getListCarByInvoiceNo, getListPlateNumberByContractNo, getListPlateNumberByInvoiceNo, IInfoSurvey, } from "../../../../../../api/Customer_V2/customerApi_V2";
import { selectorUnitByUserPermission } from "../../../../../../store/slices/UnitByUserPermission";
import { formatQuestionList } from "./ModalSurveyInformationAdd";
import { getInfoCarCustomer } from "../../../../../../api/car/carApi";


export interface IQuestionItemTmp {
  questionId?: number
  answerId?: number,
  reason?: string

  sLAnswerId?: ISelectOption[]
}

interface ModalProps {
  isOpen: boolean
  idCustomer?: number
  infoSurveyInformationDetail?: IInfoSurvey

  resultFormSubmit?: (iSsuccess: boolean, message?: string) => void
  closeModal: (isOpen: boolean) => void
}
const ModalSurveyInformationUpdate: React.FC<ModalProps> = ({
  isOpen,
  idCustomer, infoSurveyInformationDetail,
  resultFormSubmit, closeModal
}) => {

  const pushToast = useToast()
  const pushLoading = useLoading()
  const { id, username, unit } = useSelector(selectorInfoUser)
  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)
  const [form] = Form.useForm();

  const skipEffectOnSurveyTypeChange = useRef(false);
  const skipInvoiceEffect = useRef(false);
  const skipContractEffect = useRef(false);
  const skipEffectOnNumberPlateIdChange = useRef(false);
  const skipEffectOnCarIdChange = useRef(false);
  const skipEffectOnChassisNoChange = useRef(false);

  const invoiceSearch = Form.useWatch("invoiceSearch", form);

  const surveyType = Form.useWatch("surveyType", form);
  const invoiceNo = Form.useWatch("invoiceNo", form);
  const contractNo = Form.useWatch("contractNo", form);

  const vehicleId = Form.useWatch("vehicleId", form); // tên xe
  const chassisNo = Form.useWatch("chassisNo", form); // số khung

  const [sLInvoiceNo, setSLInvoiceNo] = useState<SelectProps["options"]>([])
  const [sLContractNo, setSLContractNo] = useState<ISelectOption[]>([])

  const [sLvehicleId, setSLvehicleId] = useState<ISelectOption[]>([])
  const [sLNumberPlateId, setSLNumberPlateId] = useState<ISelectOption[]>([])
  const [sLChassisNo, setSLChassisNo] = useState<ISelectOption[]>([])
  const [sLEngineNo, setSLEngineNo] = useState<ISelectOption[]>([])


  const [sLAdminId, setSLAdminId] = useState<ISelectOption[]>([{ value: id, label: username }])
  const [sLBranchId, setSLBranchId] = useState<ISelectOption[]>([])


  const [sLQuestionSurvey, setSLQuestionSurvey] = useState<ISelectOption[]>([])


  //#region gọi api SL OP
  // số hóa đơn
  const gSLInvoices = useDebounce(async (search?: string) => {
    if (!idCustomer) {
      setSLInvoiceNo([])
      return
    }
    pushLoading(true)
    const result = await getSLInvoices(
      idCustomer,
      search
    )
    if (result?.status) {
      setSLInvoiceNo(createGroupedSelectOptions(result.data))
    }
    pushLoading(false)
  }, 1000)

  // số hơp đồng
  const gSLContractNo = useDebounce(async () => {
    if (!idCustomer) return

    const result = await getSLContracts(
      idCustomer,
    )
    if (result?.status) {
      setSLContractNo(fommatSelectOption(result.data))
    }
  }, 1000)

  //Danh sách xe theo hóa đơn
  const gSLCarByInvoiceNo = useDebounce(async () => {
    if (!invoiceNo || !idCustomer) return

    pushLoading(true)
    const result = await getSLCarByInvoiceNo(
      invoiceNo, idCustomer
    )
    if (result?.status) {
      setSLvehicleId(convertToAntdOptions(result.data))

      const allChildren = result?.data?.flatMap(g => g.children || []) || [];
      if (allChildren.length === 1) {
        form.setFieldValue("vehicleId", allChildren[0].vehicleId); //rs tên xe
      }
    }
    pushLoading(false)
  }, 1000)

  //Danh sách xe theo hợp đồng.
  const gSLCarByContractNo = useDebounce(async () => {
    if (!contractNo) return

    pushLoading(true)
    const result = await getSLCarByContractNo(
      contractNo,
    )
    if (result?.status) {
      setSLvehicleId(convertToAntdOptions(result.data))

      const allChildren = result?.data?.flatMap(g => g.children || []) || [];
      if (allChildren.length === 1) {
        form.setFieldValue("vehicleId", allChildren[0].vehicleId); //rs tên xe
      }
    }
    pushLoading(false)
  }, 1000)


  //biển số , vs số khung
  const gInfoCarCustomer = useDebounce(async () => {
    if (!idCustomer || !vehicleId) return

    pushLoading(true)
    const result = await getInfoCarCustomer(
      vehicleId, idCustomer
    )
    if (result?.status) {
      const { plateNumber, vehicleChassisNo } = result.data
      setSLChassisNo(fommatSelectOptionToUpperCase(vehicleChassisNo))
      form.setFieldValue("numberPlateId", plateNumber);
      if (vehicleChassisNo.length === 1)
        form.setFieldValue("chassisNo", vehicleChassisNo[0].id);
    }
    pushLoading(false)
  }, 1000)

  //ngày sk
  const gSLInfoExportDate = useDebounce(async () => {
    if (!contractNo || !vehicleId) return

    const result = await getSLInfoExportDate(
      contractNo, vehicleId,
    )
    if (result?.status) {
      // setSLvehicleId(fommatSelectOption(result.data))
      const deliveryDateTmp = result.data.deliveryCarDate ? dayjs(result.data.deliveryCarDate, "DD/MM/YYYY") : null;
      form.setFieldsValue({ "deliveryDate": deliveryDateTmp })
    }
  }, 1000)

  //số km
  const gSLInfoPresentMileAge = useDebounce(async () => {
    if (!invoiceNo || !vehicleId) return

    const result = await getSLInfoPresentMileAge(
      invoiceNo, vehicleId,
    )
    if (result?.status) {
      form.setFieldsValue({ "presentMileAge": result.data?.presentMileAge })
    }
  }, 1000)


  // số máy
  const gSLEngineNo = async () => {
    if (!vehicleId || !idCustomer) {
      setSLEngineNo([])
      return
    }
    const result = await getSLVehicleEngineNos(
      idCustomer, vehicleId,
    )
    if (result?.status) {
      setSLEngineNo(fommatSelectOptionToUpperCase(result.data))

      if (result.data.length === 1)
        form.setFieldValue("engineNo", result.data[0].id);
    }
  }

  //dơn vị
  const gSLBranchId = async () => {
    setSLBranchId(fommatSelectOptionUnitByUser(unitByUserPermissionSlice))
  }

  // câu hỏi
  const gSLQuestionSurvey = async () => {
    pushLoading(true)
    const result = await getSLQuestionSurvey()
    if (result?.status) {
      setSLQuestionSurvey(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLAvailableQuestions = (currentIndex: number) => {
    const list = form.getFieldValue("questionList") || [];

    const selectedIds = list
      .map((item: any, index: number) =>
        index !== currentIndex ? item?.questionId : null
      )
      .filter(Boolean);

    return sLQuestionSurvey.filter(
      opt => !selectedIds.includes(opt.value)
    );
  };
  //#endregion

  //	Thông tin xe theo hóa đơn
  const gInfoCarByInvoiceNo = async () => {
    if (!idCustomer || !invoiceNo) return
    pushLoading(true)
    const result = await getListPlateNumberByInvoiceNo(
      idCustomer, invoiceNo
    )
    if (result?.status) {
      setSLNumberPlateId(fommatSelectOptionToUpperCase(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  //	Danh sách biển số theo hợp đồng.
  const gListPlateNumberByContractNo = async () => {
    if (!idCustomer || !contractNo) return
    pushLoading(true)
    const result = await getListPlateNumberByContractNo(
      idCustomer, contractNo
    )
    if (result?.status) {
      setSLNumberPlateId(fommatSelectOptionToUpperCase(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gfillSLAnswerIdForQuestionList = async (
    questionList: IQuestionItemTmp[]
  ) => {
    const result = await Promise.all(
      questionList.map(async (item) => {
        if (!item.questionId) return item;

        const sLAnswerId = fommatSelectOption((await getSLAnswerOptions(item.questionId)).data ?? []);

        return {
          ...item,
          sLAnswerId
        };
      })
    );
    form.setFieldsValue({ "questionList": result })
  };

  const onChangeQuestionId = useDebounce(async (questionId: number, index: number) => {
    console.log(questionId, index)
    pushLoading(true)
    const result = await getSLAnswerOptions(questionId);
    if (result?.status) {
      form.setFieldValue(
        ["questionList", index],
        {
          ...form.getFieldValue(["questionList", index]),
          questionId,
          answerId: undefined,
          reason: undefined,

          sLAnswerId: fommatSelectOption(result.data),
        }
      );
    }
    pushLoading(false)
  }, 500)

  const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {
    if (!idCustomer || !infoSurveyInformationDetail?.id) return
    pushLoading(true)

    const {
      surveyType, docDate,
      contactType, vehicleId, numberPlateId, chassisNo,
      engineNo, invoiceNo, contractNo, deliveryDate,
      presentMileAge, adminId, branchId, questionList
    } = values



    const docDateTmp = docDate ? docDate?.format('YYYY/MM/DD') : undefined
    const deliveryDateTmp = deliveryDate ? deliveryDate?.format('YYYY/MM/DD') : undefined

    const questionListTmp = formatQuestionList(questionList ?? [])

    const result = await editCustomerSurvey(
      infoSurveyInformationDetail?.id, idCustomer, surveyType, docDateTmp,
      contactType, undefined, undefined, chassisNo,
      engineNo, invoiceNo, contractNo, deliveryDateTmp,
      presentMileAge, adminId, branchId, questionListTmp,
      vehicleId
    )
    if (result?.status) {
      resultFormSubmit?.(true, result?.message)
    } else {
      resultFormSubmit?.(false, result?.message)
    }
    pushLoading(false)

  }, 1000)

  //#region Thay đổi form rs
  useEffect(() => {
    if (!isOpen) return
    if (skipEffectOnSurveyTypeChange.current) {
      skipEffectOnSurveyTypeChange.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("invoiceNo", undefined); //rs Số hóa đơn
      form.setFieldValue("contractNo", undefined); //rs Số hhợp đồng

      form.setFieldValue("vehicleId", undefined); //rs  biển số xe
      form.setFieldValue("numberPlateId", undefined); //rs  biển số xe
      form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
      form.setFieldValue("engineNo", undefined); //rs bSố máy
      form.setFieldValue("presentMileAge", undefined); //rs số km
      form.setFieldValue("deliveryDate", undefined); //rs ngày
    }
  }, [surveyType]);

  useEffect(() => {
    if (!isOpen) return
    if (invoiceNo)
      gSLCarByInvoiceNo()
    if (skipInvoiceEffect.current) {
      skipInvoiceEffect.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("vehicleId", undefined); //rs  biển số xe
      form.setFieldValue("numberPlateId", undefined); //rs  biển số xe
      form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
      form.setFieldValue("engineNo", undefined); //rs bSố máy
      form.setFieldValue("presentMileAge", undefined); //rs số km
      form.setFieldValue("deliveryDate", undefined); //rs ngày
    }
  }, [invoiceNo]);

  useEffect(() => {
    if (!isOpen) return

    if (contractNo)
      gSLCarByContractNo()
    if (skipContractEffect.current) {
      skipContractEffect.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("vehicleId", undefined); //rs  biển số xe
      form.setFieldValue("numberPlateId", undefined); //rs  biển số xe
      form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
      form.setFieldValue("engineNo", undefined); //rs bSố máy
      form.setFieldValue("presentMileAge", undefined); //rs số km
      form.setFieldValue("deliveryDate", undefined); //rs ngày
    }
  }, [contractNo]);



  useEffect(() => {
    if (!isOpen) return

    gInfoCarCustomer()

    gSLInfoExportDate()
    gSLInfoPresentMileAge()

    if (skipEffectOnCarIdChange.current) {
      skipEffectOnCarIdChange.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
      form.setFieldValue("engineNo", undefined); //rs bSố máy

      form.setFieldValue("presentMileAge", undefined); //rs số km
      form.setFieldValue("deliveryDate", undefined); //rs số km
    }
  }, [vehicleId]);

  useEffect(() => {
    if (!isOpen) return

    gSLEngineNo()
    if (skipEffectOnChassisNoChange.current) {
      skipEffectOnChassisNoChange.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("engineNo", undefined); //rs bSố máy
    }
  }, [chassisNo]);

  //#endregion

  useEffect(() => {
    if (isOpen) {
      if (!sLInvoiceNo?.length)
        gSLInvoices()
      if (!sLContractNo.length)
        gSLContractNo()
      if (!sLBranchId.length)
        gSLBranchId()
      if (!sLQuestionSurvey.length)
        gSLQuestionSurvey()

      if (infoSurveyInformationDetail) {

        skipEffectOnSurveyTypeChange.current = true;
        skipInvoiceEffect.current = true;
        skipContractEffect.current = true;
        skipEffectOnNumberPlateIdChange.current = true;
        skipEffectOnCarIdChange.current = true;
        skipEffectOnChassisNoChange.current = true;


        const {
          customerId, surveyType, docDate,
          contactType, numberPlateId, chassisNo,
          engineNo, invoiceNo, contractNo, deliveryDate,
          presentMileAge, adminId, branchId, questionList,
          vehicleId, numberPlate
        } = infoSurveyInformationDetail

        gfillSLAnswerIdForQuestionList(questionList || [])

        const docDateTmp = docDate ? dayjs(docDate, "DD/MM/YYYY") : null;
        const deliveryDateTmp = deliveryDate ? dayjs(deliveryDate, "DD/MM/YYYY") : null;

        form.setFieldsValue({
          surveyType,
          contactType,
          docDate: docDateTmp,
          vehicleId,
          numberPlateId: numberPlate,
          chassisNo,
          engineNo,
          invoiceNo,
          contractNo,
          deliveryDate: deliveryDateTmp,
          presentMileAge,
          adminId,
          branchId,
          // questionList

        });
      }


    } else {
      form.resetFields()
    }
  }, [isOpen])


  return (
    <Form
      layout="vertical"
      className=" custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2"
      form={form}
      onFinish={onFinish}
    >
      <ConfigProvider locale={viVN}>
        <Modal
          title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
            <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa khảo sát</span>
            <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
          </div>}
          open={isOpen}
          onCancel={() => closeModal(false)}
          centered
          className=" custom-modal-ant-history"
          destroyOnClose
          closeIcon={false}
          footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
            <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
              <Button
                onClick={() => closeModal(false)}
              >
                Huỷ
              </Button>
              <Button
                type="primary"
                onClick={() => form.submit()}
              >
                Lưu
              </Button>
            </div>
          </div>}
        >
          <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
            <span className="text-base text-344054 fw-500 font-medium">Thông tin chung</span>

            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                layout="vertical"
                label={<span>
                  Loại tương tác <span className="text-FF1D1D">*</span>
                </span>}
                name="surveyType"
                rules={[
                  { required: true, message: 'Vui lòng chọn loại tương tác' }
                ]}
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Loại tương tác"
                  options={dataSurveyInformationInteractionType}
                />
              </Form.Item>

              <Form.Item
                layout="vertical"
                label="Phân loại liên hệ"
                name="contactType"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Phân loại liên hệ"
                  options={dataInteractionCategory}
                />
              </Form.Item>
            </div>
            {/* Row 1 */}
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                layout="vertical"
                label={
                  <span>Ngày ghi nhận <span className="text-FF1D1D">*</span></span>
                }
                name="docDate"
                rules={[
                  { required: true, message: 'Vui lòng chọn ngày ghi nhận' }
                ]}
              >
                <DatePicker
                  className="w-full custom-input-date"
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </div>
            <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin xe</span>
            <div className="grid grid-cols-2 gap-4">
              {/* dịch vụ */}

              <Form.Item name="invoiceSearch" hidden />

              <Form.Item
                layout="vertical"
                label={<span>
                  Số hóa đơn <span className="text-FF1D1D">*</span>
                </span>}
                name="invoiceNo"
                rules={[
                  { required: true, message: "Vui lòng chọn số hóa đơn" },
                ]}
                hidden={surveyType !== SURVEYTYPE.SERVICESURVEY}
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Số hóa đơn"
                  showSearch
                  allowClear
                  filterOption={false}
                  searchValue={invoiceSearch}
                  onSearch={(value) => {
                    form.setFieldValue("invoiceSearch", value);
                    gSLInvoices(value);
                  }}
                  options={sLInvoiceNo}
                />
              </Form.Item>

              {/* kinh doanh */}
              <Form.Item
                layout="vertical"
                label="Số hợp đồng"
                name="contractNo"
                hidden={surveyType === SURVEYTYPE.SERVICESURVEY}
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Số hợp đồng"
                  options={sLContractNo}
                />
              </Form.Item>
              <Form.Item

                layout="vertical"
                label="Tên xe"
                name="vehicleId"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Tên xe"
                  allowClear
                  options={sLvehicleId}
                  disabled={!contractNo && !invoiceNo}
                />
              </Form.Item>
            </div>
            {/* Row 3 */}
            <div className="grid grid-cols-2 gap-4">

              <Form.Item

                layout="vertical"
                label="Biển số xe"
                name="numberPlateId"
              >
                <Input
                  className="custom-input-css custom-page-css border"
                  placeholder="Biển số xe"
                  disabled
                // options={sLplateNumberId}
                />
              </Form.Item>
              {/* // dịch vụ */}
              <Form.Item

                layout="vertical"
                label="Số KM hiện tại"
                name="presentMileAge"

                hidden={surveyType !== SURVEYTYPE.SERVICESURVEY}
              >
                <InputNumber<number>
                  className="w-full"
                  // addonAfter="Km"
                  controls={false}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  }
                  parser={(value) =>
                    value?.replace(/\./g, '') as unknown as number
                  }
                  disabled={!vehicleId}
                />
              </Form.Item>
              {/* // kinh doanh */}
              <Form.Item

                hidden={surveyType === SURVEYTYPE.SERVICESURVEY}
                layout="vertical"
                label="Ngày xuất kho SR"
                name="deliveryDate"
              >
                <DatePicker
                  className="w-full custom-input-date"
                  format="DD/MM/YYYY"
                  disabled={!vehicleId}
                />
              </Form.Item>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item

                layout="vertical"
                label="Số khung"
                name="chassisNo"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Số khung"
                  disabled={!vehicleId}
                  options={sLChassisNo}
                />
              </Form.Item>
              <Form.Item

                layout="vertical"
                label="Số máy"
                name="engineNo"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Số máy"
                  disabled={!chassisNo}
                  options={sLEngineNo}
                />
              </Form.Item>
            </div>

            <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin khảo sát</span>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item

                layout="vertical"
                label="Nhân viên tiếp nhận"
                name="adminId"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Nhân viên tiếp nhận"
                  options={sLAdminId}
                />
              </Form.Item>

              <Form.Item

                layout="vertical"
                label="Đơn vị:"
                name="branchId"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Đơn vị"
                  options={sLBranchId}
                />
              </Form.Item>
            </div>
            <div className="custom-page-css border rounded">
              {/* Header */}
              <div className="custom-page-css grid grid-cols-12 gap-2 bg-096DD9 rounded-t text-white text-sm font-medium py-2 pr-2">
                <div className="col-span-1 text-sm text-center">STT</div>
                <div className="col-span-5">Câu hỏi khảo sát</div>
                <div className="col-span-3">Câu trả lời</div>
                <div className="col-span-3">Lý do (nếu có)</div>
              </div>
              <Form.List
                name="questionList"
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name }, index) => (
                      <div
                        key={key}
                        className="grid grid-cols-12 gap-2  py-2 border-t items-center pr-2"
                      >
                        <div className="col-span-1 text-sm text-center">{index + 1}</div>

                        <div className="col-span-5">
                          <Form.Item

                            layout="vertical"
                            className="mb-0"
                            name={[name, "questionId"]}
                            rules={[{ required: true, message: "Chọn câu hỏi" }]}
                          >
                            <Select
                              placeholder="Chọn câu hỏi"
                              optionFilterProp="label"
                              options={gSLAvailableQuestions(name)}
                              onChange={(value) => onChangeQuestionId(value, name)}
                            />
                          </Form.Item>
                        </div>

                        <div className="col-span-3">
                          <Form.Item

                            layout="vertical" shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              const questionId = getFieldValue([
                                "questionList", name, "questionId",
                              ]);
                              const options = getFieldValue([
                                "questionList", name, "sLAnswerId",
                              ]);
                              return (

                                <Form.Item

                                  layout="vertical"
                                  className="mb-0"
                                  name={[name, "answerId"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Chọn câu trả lời",
                                    },
                                  ]}
                                >
                                  <Select
                                    placeholder="Câu trả lời"
                                    options={options}
                                    disabled={!questionId}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>

                        </div>

                        <div className="col-span-3 flex gap-2">
                          <Form.Item

                            layout="vertical" shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              const answerId = getFieldValue([
                                "questionList", name, "answerId",
                              ]);

                              return (
                                <Form.Item

                                  layout="vertical"
                                  className="mb-0 flex-1"
                                  name={[name, "reason"]}
                                  rules={[
                                    {
                                      required: answerId === 2,
                                      message: "Vui lòng nhập lý do",
                                    },
                                  ]}
                                >
                                  <Input
                                    className="custom-input-css"
                                    placeholder="Lý do (nếu có)"
                                    maxLength={225}
                                    disabled={!answerId}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>

                          {
                            fields.length > 1 && (
                              <Tooltip title="Xóa câu hỏi">
                                <Button
                                  icon={<DeleteOutlined />}
                                  danger
                                  type="text"
                                  onClick={() => remove(name)}
                                />
                              </Tooltip>
                            )}
                        </div>
                      </div>
                    ))}
                    {/* Footer buttons */}
                    <div className="custom-page-css flex justify-between items-center mt-4 px-3">
                      <Button type="link" onClick={() => add({})}>
                        + Thêm câu hỏi
                      </Button>

                      <Button
                        type="link"
                        onClick={() => form.setFieldValue("questionList", [{}])}
                      >
                        Đặt lại
                      </Button>
                    </div>
                  </>
                )}
              </Form.List>
            </div>
          </div>
        </Modal>
      </ConfigProvider>
    </Form >
  )
}
export default ModalSurveyInformationUpdate
